import script from "./ReachedLimitActionsHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReachedLimitActionsHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ReachedLimitActionsHeader.vue?vue&type=style&index=0&id=873431f4&lang=sass"

const __exports__ = script;

export default __exports__